export default [
    {
        path: "payroll",
        name: "settings-payroll",
        redirect: { name: "settings-payroll-general" },
        component: () => import("@/views/settings/views/payroll/Payroll.vue"),
        meta: {
            section: 17,
            pageTitle: "Settings",
            breadcrumb: [
                {
                    text: "Payroll",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "General",
                    name: "settings-payroll-general",
                },
                {
                    title: "Payments",
                    name: "settings-payroll-payments",
                },
                {
                    title: "Holidays",
                    name: "settings-payroll-holidays",
                },
                {
                    title: "Labor Regime",
                    name: "settings-payroll-labor-regime",
                },
                {
                    title: "Bonus",
                    name: "settings-payroll-bonus",
                },
                {
                    title: "BONOS VARIABLES",
                    name: "settings-payroll-variable-bonus",
                },
                {
                    title: "TIPOS DE ACUERDOS",
                    name: "settings-payroll-tipos-acuerdos",
                },
            ],
        },

        children: [
            {
                path: "general",
                name: "settings-payroll-general",
                component: () => import("@/views/settings/views/payroll/components/general/Settings.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "General",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "payments",
                name: "settings-payroll-payments",
                component: () => import("@/views/settings/views/payroll/components/setting-modules/AllPaymentSetting.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Payments",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "holidays",
                name: "settings-payroll-holidays",
                component: () => import("@/views/settings/views/payroll/components/holidays/HolidaysTable.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Holidays",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "labor-regime",
                name: "settings-payroll-labor-regime",
                component: () => import("@/views/settings/views/payroll/components/labor-regime/LaborRegimeGrid.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Labor Regime",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "bonus",
                name: "settings-payroll-bonus",
                component: () => import("@/views/settings/views/payroll/components/bonus/BonusGrid.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Bonus",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "variable-bonus",
                name: "settings-payroll-variable-bonus",
                component: () => import("@/views/settings/views/payroll/components/variable-bonus/VariableBonusGrid.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Variable Bonus",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "tipos-acuerdos",
                name: "settings-payroll-tipos-acuerdos",
                component: () => import("@/views/settings/views/payroll/components/tipos-acuerdos/TiposAcuerdosGrid.vue"),
                meta: {
                    section: 17,
                    pageTitle: "Payroll",
                    breadcrumb: [
                        {
                            text: "Tipos de Acuerdos",
                            active: true,
                        },
                    ],
                },
            },
        ],
    },
];